



































































































































































import { Vue, Component, Prop } from 'vue-property-decorator'
import SexSelect from "@/components/exam/SexSelect.vue"
import PhotoUploader from "@/components/exam/PhotoUploader.vue"
import BirthdayPicker from "@/components/exam/BirthdayPicker.vue"
import EnrollTextarea from "@/components/exam/EnrollTextarea.vue"
import { getKey } from '@/utils/key'
import type { SecondDegree } from '@/models/enrolls/secondDegree'

@Component({
  components: { BirthdayPicker, EnrollTextarea, SexSelect, PhotoUploader }
})
export default class ArtStudentEnrollForm extends Vue {
  @Prop({ required: true }) value!: SecondDegree
  @Prop({ default: false }) print!: boolean
  @Prop({ default: '' }) title!: string
  @Prop({ default: [] }) choices!: string[]
  getKey = getKey

  get form() {
    return this.value
  }

  set form(value: SecondDegree) {
    this.$emit('update:value', value)
  }


  get noticeline() {
    return ''
  }
}
